module.exports = __webpack_public_path__ + "img/icon_video.b0598197.png";